import { Component, Input } from '@angular/core';
import { BaseControlValueAccessor } from "../../../../util/form/BaseControlValueAccessor";
import { getNgValueAccessorProvider } from "../../../../util/form/value-accessor-export-functions";

@Component({
  standalone: true,
  selector: 'app-table-group-icon',
  templateUrl: './table-group-icon.component.html',
  styleUrls: ['./table-group-icon.component.scss'],
  providers: [
    ...getNgValueAccessorProvider(TableGroupIconComponent),
  ],
})
/**
 * It is possible to use FormControls
 *
 * Example: <app-table-group-icon [formControl]="yourFormGroup.controls.yourControl"></app-table-group-icon>
 */
export class TableGroupIconComponent extends BaseControlValueAccessor<boolean> {
  // eslint-disable-next-line
  @Input('opened') value: boolean = false;

  changeIcon(): void {
    this.onModelChange(!this.value);
  }
}
